module.exports = __webpack_public_path__ + "img/logo-blue.71e73379.png";